import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { removeSystemFieldNamePrefix } from '../../utils/Utilities';

export const CustomFieldLabel = ({
  fieldName,
  isSystem = false,
  fontStyle = 'italic',
  ...props
}: {
  fieldName: string;
  isSystem: boolean;
  fontStyle?: string;
}) => {
  const { t } = useTranslation('translation');

  if (isSystem) {
    return (
      <Tooltip title={t('ideaManagement.general.systemFieldToolTip')} arrow>
        <span
          className="fs-exclude"
          data-dd-action-name="FIM 3 System Custom Field - tooltip label redacted"
          style={{ fontStyle: fontStyle || 'italic' }}
          {...props}
        >
          {removeSystemFieldNamePrefix(fieldName)}
        </span>
      </Tooltip>
    );
  }

  return (
    <span
      className="fs-exclude"
      data-dd-action-name="FIM 3 Custom Field - label redacted"
      data-testid={`fim3-custom-field-label-${fieldName}`}
      {...props}
    >
      {fieldName}
    </span>
  );
};
